import { rest } from 'msw'
export default [
  /**
   * 意見・問い合わせ内容登録
   */
  rest.post('/api/v2/send_inquiry', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        error: {
          errorCode: 0,
          errorMessage: '',
          errorMessageDetail: '',
        },
        data: {
          status: '1',
          responseTime: '915148799',
        },
      })
    )
  }),
]
